import { message } from 'antd'
import {
  getServiceList,
  deleteService,
  createService
} from "../../../../services/meetingManage/serviceManage";

const initState = {
	serviceList: [],
	spinProps: {
		spinning: false,
		tip: '加载中...'
	},
	pageInfo:{
		page:1,
		totalPages:1,
		totalElements:1
	},
	page:1,
	pageSize:10,
};

export default {
	namespace: "serviceManage",
	
	state: initState,
	
	effects: {
		*fetchList({ params },{ call, put }){
			try {
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:true,
							tip:'加载中...'
						}
					}
				})
				const response = yield call(getServiceList,params)
				const { content, totalPages, totalElements } = response
				yield put({
					type:'save',
					payload:{
						serviceList: content,
						pageInfo: {
							totalPages,
							totalElements
						},
						spinProps:{
							spinning: false
						}
					}
				})
			}
			catch(error){
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:false
						}
					}
				})
			}
		},
		*fetchDelService({params}, { call, put, }){
			try {
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:true,
							tip:'加载中....'
						}
					}
				})
				yield call(deleteService,params)
				message.success('删除成功')
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:false
						}
					}
				})
				return Promise.resolve('success')
			} 
			catch(error) {
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:false
						}
					}
				})
				return Promise.reject(String(error))
			}
		},
		*fetchCreateService({params}, { call, put }) {
			try {
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:true,
							tip:'加载中...'
						}
					}
				})
				yield call(createService,params)
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:false
						}
					}
				})
				return Promise.resolve('success')
			}
			catch(error){
				yield put({
					type:'save',
					payload:{
						spinProps:{
							spinning:false
						}
					}
				})
				return Promise.reject(String(error))
			}
		}
	},

	reducers: {
		save(state, {payload}){
			return {
				...state,
				...payload
			}
		},
		initState(){
			return {
				...initState
			}
		}
	}
};
